import React from "react";
import BlogItem from "./BlogItem";

export default function Blogs({ data }) {
  const blogs = data.blogs || [];
  document.title = "Blogs - Aritra";
  return (
    <div className="page container-narrow">
      <section className="section-tight">
        <p className="eyebrow">Writing</p>
        <h2 className="section-title">Technical articles and guides</h2>
        <p className="muted">Insights, tutorials, and experiments from my dev journey.</p>
      </section>
      <section className="section-tight">
        <div className="row g-4">
          {blogs.map((blog) => (
            <div className="col-md-4" key={blog.title}>
              <BlogItem
                title={blog.title}
                description={blog.brief}
                project_url={`https://aritrablogs.hashnode.dev/${blog.slug}`}
                imageUrl={blog.coverImage}
              />
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
